import axios from 'axios'
import { getToken, gettoken_type, removeToken, getTime, setTime } from '@/utils/auth'
import {MessageBox,Message} from 'element-ui'
// import store from '@/store/index'
import qs from 'query-string'
import "../assets/css/public.css"
class BaseModule {
    constructor() {
        const $http = axios.create({
            baseUrl: process.env.API_ROOT//??????
        });
        $http.interceptors.request.use( res => {
            res.headers['Authorization'] = gettoken_type() + " " + getToken();
            if (getTime()) {
                res.headers['Last-Refresh'] = getTime();
            } else {
                setTime(new Date(new Date() - 3*60*60*1000).toUTCString());
                res.headers['Last-Refresh'] = new Date(new Date() - 3*60*60 *1000).toUTCString();
            }
            return res
        }, error => {
            console.log("error  request:    " + error)
        });
        $http.interceptors.response.use(
            response => {
                var token = response.headers.authorization;
                var timekey = response.headers['last-refresh'];
                if (token) {
                    var reg = gettoken_type() + " ";
                    var newToken = token.replace(reg, '');
                    setToken(newToken)
                    // 如果 header 中存在 token，那么替换本地的 token
                }
                if(timekey){
                    setTime(timekey)
                }
                const res = response
                return res
            },
            error => {
                //状态处理
                let mes = '';
                switch (error.response.status) {
                    case 400:
                    switch (error.response.data.status) {
                        case 100:
                        mes = '请求体错误,如请求体格式不对';
                        break;
                        case 101:
                        mes = '请求体错误,如缺少必要的请求参数、参数不合法';
                        break;
                    }
                    break;
                    case 401:
                        var authenticate = error.response.headers['www-authenticate'];
                        var n=[];
                        authenticate.replace(/\d+/g, function () {
                            return n.push(arguments[0]);
                        });
                        //选出最长的
                        // var i=0;
                        // for(let j=0;j<n.length;j++){
                        //     if(n[j].length>=i){
                        //         i=n[j].length;
                        //         var max=j;
                        //     }
                        // }
                        var i;
                        for(let j=0;j<n.length;j++){
                            if(n[j].length==10){
                                i=parseInt(n[j])*1000;;
                            }
                        }
                        if(i===undefined){
                            MessageBox.confirm(
                                '登录超时',
                                '重新登录', {
                                  confirmButtonText: '确定',
                                  showCancelButton: false,
                                  type: 'error'
                                }
                              ).then(() => {
                                removeToken()
                                location.reload()
                              })
                        }else{
                            var dateFormat = function (timestamp, formats) {
                                // formats格式包括
                                // 1. Y-m-d
                                // 2. Y-m-d H:i:s
                                // 3. Y年m月d日
                                // 4. Y年m月d日 H时i分
                                formats = formats || 'Y-m-d';
                                var zero = function (value) {
                                    if (value < 10) {
                                        return '0' + value;
                                    }
                                    return value;
                                };
                            
                                var myDate = timestamp? new Date(timestamp): new Date();
                            
                                var year = myDate.getFullYear();
                                var month = zero(myDate.getMonth() + 1);
                                var day = zero(myDate.getDate());
                            
                                var hour = zero(myDate.getHours());
                                var minite = zero(myDate.getMinutes());
                                var second = zero(myDate.getSeconds());
                            
                                return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
                                    return ({
                                        Y: year,
                                        m: month,
                                        d: day,
                                        H: hour,
                                        i: minite,
                                        s: second
                                    })[matches];
                                });
                            };
                            let time = dateFormat(i,'Y年m月d日H时i分');
                            MessageBox.confirm('您的账号已于'+time+'在其它设备登录，请知晓。', '登录提醒', {
                                confirmButtonText: '我知道啦',
                                customClass:'messagebox-width',
                                confirmButtonClass:'button-color',
                                showCancelButton: false,
                                closeOnClickModal:false,
                                closeOnPressEscape:false,
                                closeOnHashChange:false,
                                showClose:false,
                                center: true
                                }).then(() => {
                                removeToken()
                                location.reload()
                            })
                        }
                    break;
                    case 403:
                    switch (error.response.data.status) {
                        case 110:
                        mes = '所请求的接口对于所携带的token其所属用户来说权限不足';
                        break;
                        case 111:
                        mes = '所请求的接口使用了权限控制，但未在系统中登记权限路由名称';
                        break;
                        case 112:
                        mes = '所请求的接口使用了权限控制，但未在系统中登记权限路由所属角色关联';
                        break;
                    }
                    break;
                    default:
                        mes = '服务器出错';
                        break;
                }
                if (error.response.status === 500) {
                        Message({
                        message: mes,
                        type: 'error',
                        duration: 2 * 1000
                    })
                }else {
                    if (error.response.data.status < 200) {
                        Message({
                            message: mes,
                            type: 'error',
                            duration: 2 * 1000
                        })
                    }
                }
                return Promise.reject(error.response)
            }
        )
        this.$http = $http;
        this.dataMethodDefaults = {
            headers: {
                
            },
            transformRequest: [function (data) {
                return qs.stringify(data)
            }]
        };
    }

    get(url, config = {}) {
        return this.$http.get(url, config)
    }

    post(url, data = undefined, config = {}) {
        return this.$http.post(url, data, config)
    }

    put(url, data = undefined, config = {}) {
        return this.$http.put(url, data, config)
    }

    delete(url, config = {}) {
        return this.$http.delete(url, config)
    }
}

export default BaseModule



// WEBPACK FOOTER //
// ./src/api/BaseModule.js